import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from '../assets/icon-logo.png';
import formatterBR, { formatter } from "../functions/formatCurrency";

import paymentServices from "./academy/paymentServices";
import productServices from "./admFin/productServices";
import partnerServices from './admFin/partnerServices';
import billServices from './admFin/billServices';

const generatePDF = (title, fileName,header, rows) =>{
    if(fileName === '' || typeof fileName !== 'string')
        fileName = 'relatorio';
    const doc = new jsPDF({orientation: "landscape", unit: "mm" ,format: [200, 400]});

    const xOffset = doc.internal.pageSize.getWidth();
    
    doc.addImage(logo, 'PNG', xOffset / 2-10, 2, 20, 20);
    
    doc.text(title, xOffset / 2, 30, { align: 'center' });
    
    doc.autoTable(header, rows,{
        startY: 35,
        didParseCell: (data) => {
            if (data.section === 'head') {
                data.cell.styles.fillColor = "#0F0963";
            }
        }
    })
    
    const name = fileName + ".pdf";
    doc.save(name);
}

const generatePDFManyTables = (title, fileName, tables, options = {bold: false}) =>{
    if(fileName === '' || typeof fileName !== 'string')
        fileName = 'relatorio';
    const doc = new jsPDF({orientation: "landscape", unit: "mm" ,format: [200, 400]});

    const xOffset = doc.internal.pageSize.getWidth();
    
    doc.addImage(logo, 'PNG', xOffset / 2-10, 2, 20, 20);
    
    doc.text(title, xOffset / 2, 30, { align: 'center' });

    for(const table of tables) {
        doc.text(table.title, xOffset / 2, doc.autoTable.previous ? doc.autoTable.previous.finalY + 10 : 45, { align: 'center' });
        doc.autoTable(table.headers, table.rows,{
            startY: doc.autoTable.previous ? doc.autoTable.previous.finalY + 15 : 50,
            didParseCell: (data) => {
                if (data.section === 'head') {
                    data.cell.styles.fillColor = "#0F0963";
                }
                if(data.row.index === table.rows.length -1 && options.bold) {
                    data.cell.styles.fontStyle = 'bold';
                    //data.cell.styles.fontSize = 14;
                    data.cell.styles.textColor = 0;
                }
            }
        })
    }
    
    
    const name = fileName + ".pdf";
    doc.save(name);
    doc.autoTable.previous = null;
}


//Academy reports

const generateReportStudents = async (students, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) fields = separateHeaderField(studentFields)[1];
    const reportRows = [];
    for await (const student of students) {
        const actualRow = [];
        const response = await paymentServices.getEnrollments(student.id);
        if (response.status >= 400) {
            throw new Error(`Não foi possível obter os dados da matricula do aluno ${student.nome}`);
        }
        else {
            const enrollments = response.data;

            const lastEnrollment = enrollments.matriculas.find(matricula => matricula.id === enrollments.matricula);

            for (const column of fields) {
                if (column in student) {
                    if (column === 'inadimplente') {
                        actualRow.push(student[column] ? "Sim" : "Não");
                    }
                    else if (column === 'bolsa' && lastEnrollment !== undefined) {
                        actualRow.push(lastEnrollment[column] ? "Sim" : "Não");
                    }
                    else if (column === 'turma') {
                        actualRow.push(student[column] !== null ? student[column].nome : "Sem Turma");
                    }
                    else if (column === 'data_nascimento') {
                        const date = new Date(student[column].replace(/-/g, '/'));
                        actualRow.push(date.toLocaleDateString());
                    }
                    else if (column === 'nome') {
                        actualRow.push(student[column] + " " + student['sobrenome']);
                    }
                    else if (column === 'nome_responsavel') {
                        actualRow.push(student[column] + " " + student['sobrenome_responsavel']);
                    }
                    else if (column === 'telefone'){
                        actualRow.push(student['ddi'] + " " + student[column]);
                    }
                    else {
                        actualRow.push(student[column]);
                    }
                }
                else {
                    if (column === 'email') {
                        actualRow.push(student.user.email);
                    }
                    else if (lastEnrollment !== undefined) {
                        if (column === 'proximo_pagamento' && lastEnrollment[column]) {
                            const date = new Date(lastEnrollment[column].replace(/-/g, '/'));
                            actualRow.push(date.toLocaleDateString());
                        }
                        else {
                            actualRow.push(lastEnrollment[column]);
                        }
                    }
                    else {
                        actualRow.push(" ");
                    }
                }
            }
            reportRows.push(actualRow);
        }
    }

    const headers = fields.map(field => {
        const objArray = studentFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title,fileName, headers, reportRows);
}

const generateReportCoaches = async (coaches, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(coachFields)[1];
    }
    const reportRows = [];
    for (const coach of coaches) {
        const actualRow = [];

        for (const column of fields) {
            if (column in coach) {
                if (column === 'data_nascimento') {
                    const date = new Date(coach[column].replace(/-/g, '/'));
                    actualRow.push(date.toLocaleDateString());
                }
                else if (column === 'nome') {
                    actualRow.push(coach[column] + " " + coach['sobrenome']);
                }
                else if (column === 'telefone'){
                    actualRow.push(coach['ddi'] + " " + coach[column]);
                }
                else {
                    actualRow.push(coach[column]);
                }
            }
            else {
                if (column === 'email') {
                    actualRow.push(coach.user.email);
                }
                else {
                    actualRow.push(" ");
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = coachFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportClasses = async (classes, title, month, year, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(classFields)[1];
    }
    const reportRows = [];
    const real = Intl.NumberFormat('pt-br', {
        style: "currency",
        currency: "BRL"
    });
    for await (const klass of classes) {
        const actualRow = [];
        const response = await paymentServices.getFinancialReport(klass.id, year, month);

        if (response.status >= 400) {
            throw new Error("Não foi possível gerar o relatório financeiro");
        }
        else {
            const financialReport = response.data;

            for (const column of fields) {
                if (column in klass) {
                    actualRow.push(klass[column]);
                }
                else {
                    if (column in financialReport) {
                        if (column === 'faturamento') {
                            actualRow.push(real.format(financialReport[column]));
                        }
                        else {
                            actualRow.push(financialReport[column]);
                        }
                    }
                    else {
                        actualRow.push(" ");
                    }
                }
            }
            reportRows.push(actualRow);
        }
    }
    const headers = fields.map(field => {
        const objArray = classFields.find(obj => obj.field === field);
        return objArray.header;
    });
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportCallLists = (students, title, fileName = "relatorio") =>{
    const fields = separateHeaderField(callListFields)[1];
    console.log(fields)
    const reportRows = [];
    for (const student of students) {
        const actualRow = [];

        for (const column of fields) {
            if (column in student) {
                if(column === 'nome') {
                    actualRow.push(student[column] + " " + student['sobrenome']);
                }
                else {
                    actualRow.push(student[column]);
                }
            }
            else {
                    actualRow.push(student.presenca[column] ?"Sim" : "Não");
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = callListFields.find(obj => obj.field === field);
        return objArray.header;
    });
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportAcademyBills = async (bills, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(academyBillFields)[1];
    }
    const reportRows = [];
    for (const bill of bills) {
        const actualRow = [];

        for (const column of fields) {
            if (column in bill) {
                if(column === 'paga'){
                    actualRow.push(bill[column] ? "Sim" : "Não");
                }
                else if(column.includes("valor") && bill[column] !== null){
                    actualRow.push(formatterBR.format(bill[column]))   
                }
                else if(column.includes("data") && bill[column] !== null) {
                    const date = new Date(bill[column].replace(/-/g, '/'));
                    actualRow.push(date.toLocaleDateString());
                }
                else{
                    actualRow.push(bill[column]);
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = billFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const studentFields = [
    {
        header: 'ID',
        field: 'id'
    },
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Responsável',
        field: 'nome_responsavel'
    },
    {
        header: 'Data de Nascimento',
        field: 'data_nascimento'
    },
    {
        header: 'Cidade',
        field: 'cidade'
    },
    {
        header: 'Logradouro',
        field: 'logradouro'
    },
    {
        header: 'Bairro',
        field: 'bairro'
    },
    {
        header: 'CEP',
        field: 'cep'
    },
    {
        header: 'Telefone',
        field: 'telefone'
    },
    {
        header: 'Email',
        field: 'email'
    },
    {
        header: 'Turma',
        field: 'turma'
    },
    {
        header: 'Inadimplente',
        field: 'inadimplente'
    },
    {
        header: 'Proximo Pagamento',
        field: 'proximo_pagamento'
    },
    {
        header: 'Parcelas Totais',
        field: 'parcelas_totais'
    },
    {
        header: 'Parcelas Pagas',
        field: 'parcelas_pagas'
    },
    {
        header: 'Bolsista',
        field: 'bolsa'
    },
];

const coachFields = [
    {
        header: 'ID',
        field: 'id'
    },
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Email',
        field: 'email'
    },
    {
        header: 'Telefone',
        field: 'telefone'
    },
    {
        header: 'Data de Nascimento',
        field: 'data_nascimento'
    },
    {
        header: 'Cidade',
        field: 'cidade'
    },
    {
        header: 'Logradouro',
        field: 'logradouro'
    },
    {
        header: 'Bairro',
        field: 'bairro'
    },
    {
        header: 'CEP',
        field: 'cep'
    },
];

const classFields = [
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Tipo',
        field: 'tipo'
    },
    {
        header: 'Faixa Etária',
        field: 'faixa_etaria'
    },
    {
        header: 'Número de Alunos',
        field: 'numero_alunos'
    },
    {
        header: 'Número de Vagas',
        field: 'numero_vagas'
    },
    {
        header: 'Número de Inadimplentes',
        field: 'inadimplentes'
    },
    {
        header: 'Faturamento Mensal',
        field: 'faturamento'
    },
];

const callListFields = [
    {
        header: 'ID',
        field: 'id'
    },
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Entrada Registrada',
        field: 'check_in'
    },
    {
        header: 'Saída Registrada',
        field: 'check_out'
    },
]

const academyBillFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Descrição',
        field: 'descricao'
    },
    {
        header: 'Fornecedor',
        field: 'parceiro'
    },
    {
        header: 'Cliente',
        field: 'parceiro'
    },
    {
        header: 'Centro de Custo',
        field: 'centro_de_custo'
    },
    {
        header: 'Paga',
        field: 'paga'
    },
    {
        header: 'Valor Total',
        field: 'valor_total'
    },
    {
        header: 'Valor Pago',
        field: 'valor_pago'
    },
    {
        header: 'Parcelas',
        field: 'numero_parcelas'
    },
    {
        header: 'Parcelas Pagas',
        field: 'numero_parcelas_pagas'
    },
    {
        header: 'Data de Vencimento',
        field: 'data_venc'
    },
]

const separateHeaderField = (arrayHeaderFields) => {
    const header = [];
    const fields = [];
    for (const obj of arrayHeaderFields) {
        header.push(obj.header);
        fields.push(obj.field);
    }
    return [header, fields];
}


// adm-fin reports

const generateReportBills = async (bills, filterFields,title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(billFields)[1];
    }
    const reportRows = [];
    let valorTotal = 0;
    let valorTotalPago = 0;
    for (const bill of bills) {
        let nParcelas = bill.parcelas.length
        let nParcela = 1
        for (const parcela of bill.parcelas) {

            if(!(filterFields.data_venc_min && parcela.data_venc < filterFields.data_venc_min) && 
            !(filterFields.data_venc && parcela.data_venc > filterFields.data_venc) &&
            (filterFields.status == 'Não Pagas' && parcela.paga == false || 
            filterFields.status == 'Pagas' && parcela.paga == true || 
            filterFields.status == 'Todos'
            )) {

                const actualRow = [];
        
                for (const column of fields) {
                    if(column === 'paga'){
                        actualRow.push(parcela[column] ? "Sim" : "Não");
                    }
                    else if(column.includes("valor") && parcela[column] !== null){
                        actualRow.push(formatterBR.format(parcela[column]));
                        if(column == 'valor')
                            valorTotal+= parcela[column]
                        else if(column == 'valor_pago')
                            valorTotalPago += parcela[column]
                    }
                    else if(column.includes("data") && parcela[column] !== null) {
                        const date = new Date(parcela[column].replace(/-/g, '/'));
                        actualRow.push(date.toLocaleDateString());
                    }
                    else if (column in bill) {
                        if(typeof bill[column] === 'object' && bill[column]) {
                            if(column === 'conta_bancaria') {
                                actualRow.push(`Banco: ${bill[column].banco}; Ag: ${bill[column].agencia}; Núm: ${bill[column].numero}`);
                            }
                            else {
                                actualRow.push(bill[column].nome);
                            }
                        }
                        else if (bill[column] === null) {
                            actualRow.push("");
                        }
                        else
                            actualRow.push(bill[column])
                    }
                    
                    else {
                        if(column == 'numero_parcela') {
                            actualRow.push(nParcela);
                        }
                        else if(column == 'numero_parcelas') {
                            actualRow.push(nParcelas);
                        }
                    }
                }
                reportRows.push(actualRow);
            }
            nParcela+=1;
        }
    }

    const totalRow = [];
    let addTotalRow = false;
    totalRow.push("Total: ");
    for(const column in fields) {
        if(fields[column].includes("valor")){
            addTotalRow = true;
            if(fields[column] == 'valor')
                totalRow.push(formatterBR.format(valorTotal));
            else if(fields[column] == 'valor_pago')
                totalRow.push(formatterBR.format(valorTotalPago));
        }
        else {
            if(column > 0)
                totalRow.push("");
        }
    }
    if(addTotalRow)
        reportRows.push(totalRow);
    const headers = fields.map(field => {
        const objArray = billFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportCollaboratorBills = async (bills, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(collaboratorBillFields)[1];
    }
    const reportRows = [];
    for (const bill of bills) {
        const actualRow = [];

        for (const column of fields) {
            if (column in bill) {
                if(typeof bill[column] === 'object' && bill[column]) {
                    if(column === 'conta_bancaria') {
                        actualRow.push(`Banco: ${bill[column].banco}; Ag: ${bill[column].agencia}; Núm: ${bill[column].numero}`);
                    }
                    else {
                        actualRow.push(bill[column].nome);
                    }
                }
                else if (bill[column] === null) {
                    actualRow.push("");
                }
                else {
                    if(column === 'paga'){
                        actualRow.push(bill[column] ? "Sim" : "Não");
                    }
                    else if(column.includes("valor") && bill[column] !== null){
                        actualRow.push(formatterBR.format(bill[column]))   
                    }
                    else if(column.includes("data") && bill[column] !== null) {
                        const date = new Date(bill[column].replace(/-/g, '/'));
                        actualRow.push(date.toLocaleDateString());
                    }
                    else{
                        actualRow.push(bill[column]);
                    }
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = collaboratorBillFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportStock = async (products, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(stockFields)[1];
    }
    const reportRows = [];
    for (const product of products) {
        const actualRow = [];

        for (const column of fields) {
            if (column in product) {
                if(typeof product[column] === 'object' && product[column]) {
                    actualRow.push(product[column].nome);
                }
                else if (product[column] === null) {
                    actualRow.push("");
                }
                else {
                    if(column === 'tipo'){
                        actualRow.push(productServices.productTypes[product[column]][1]);
                    }
                    else if(column === 'categoria'){
                        actualRow.push(productServices.productCategories.find(item => product[column] === item[0])[1]);
                    }
                    else {
                        actualRow.push(product[column])
                    }
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = stockFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportStockHistoric = async (historic, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(stockHistoricFields)[1];
    }
    const reportRows = [];
    for (const trade of historic) {
        const actualRow = [];

        for (const column of fields) {
            if (column in trade) {
                if(column === 'tipo'){
                    actualRow.push(productServices.stockMovementTypes.find(obj => obj[0] === trade[column])[1]);
                }
                else if (column === 'data'){
                    const date = new Date(trade[column].replace(/-/g, '/'));
                    actualRow.push(date.toLocaleDateString());
                }
                else {
                    actualRow.push(trade[column]);
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = stockHistoricFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportBankAccouts= async (bankAccounts, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(bankAccountFields)[1];
    }
    const reportRows = [];
    for (const bankAccount of bankAccounts) {
        const actualRow = [];

        for (const column of fields) {
            if (column in bankAccount) {
                if(column === 'saldo'){
                    actualRow.push(formatterBR.format(bankAccount[column]));
                }
                else {
                    actualRow.push(bankAccount[column]);
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = bankAccountFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportBankAccoutTransfers = async (bankAccountTransfers, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(bankAccountTransferFields)[1];
    }
    const reportRows = [];
    for (const bankAccountTransfer of bankAccountTransfers) {
        const actualRow = [];

        for (const column of fields) {
            if (column in bankAccountTransfer) {
                if(column === 'conta_origem' || column === 'conta_destino') {
                    actualRow.push(`Banco: ${bankAccountTransfer[column].banco}; Ag: ${bankAccountTransfer[column].agencia}; Núm: ${bankAccountTransfer[column].numero}`);
                }
                else if (bankAccountTransfer[column] === null) {
                    actualRow.push("");
                }
                else {
                    if(column === "valor"){
                        actualRow.push(formatterBR.format(bankAccountTransfer[column]))   
                    }
                    else if(column === "data") {
                        const date = new Date(bankAccountTransfer[column].replace(/-/g, '/'));
                        actualRow.push(date.toLocaleDateString());
                    }
                    else{
                        actualRow.push(bankAccountTransfer[column]);
                    }
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = bankAccountTransferFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}


const generateReportPartners= async (partners, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(partnerFields)[1];
    }
    const reportRows = [];
    for (const partner of partners) {
        const actualRow = [];

        for (const column of fields) {
            if (column in partner) {
                if(column === 'tipo'){
                    actualRow.push(partnerServices.partnerType[partner[column]][1]);
                }
                else {
                    actualRow.push(partner[column]);
                }
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = partnerFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportRecords= async (records, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(recordFields)[1];
    }
    const reportRows = [];
    for (const record of records) {
        const actualRow = [];

        for (const column of fields) {
            if (column in record) {
                actualRow.push(record[column]);
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = recordFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportCompanyBills= async (billsPerPartner, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(companyBillFields)[1];
    }
    const reportTables = [];
    
    for(const bills of billsPerPartner) {
        let parceiro = null;
        let formatCurrency;
        const actualTable = {
            title: "",
            rows: [],
            headers: [],
            total: 0 
        }
        if(bills.length > 0) {
            parceiro = bills[0].conta.parceiro;
            actualTable.title = `${parceiro.nome} - ${partnerServices.partnerServiceType[parceiro.parceria][1]}`;
            formatCurrency = formatter(bills[0].conta.moeda);
        }
    
        for (const bill of bills) {
           
            for(const installment of bill.parcelas) {
                const actualRow = [];    
               
                for (const column of fields) {
                
                    if (column in installment) {
                        if(column === 'data_pag') {
                            const date = new Date(installment[column].replace(/-/g, '/'));
                            actualRow.push(date.toLocaleDateString());
                        }
                        else {
                            actualRow.push(formatCurrency.format(installment[column]));
                            if(bill.conta.tipo === "Pagar") {
                                actualTable.total-= installment[column];
                            }
                            else {
                                actualTable.total += installment[column];
                            }
                        }
                    }
                
                    else if(column in bill.conta) {
                        if(typeof bill.conta[column] === 'object' && bill.conta[column]) {
                            if(column === 'conta_bancaria') {
                                actualRow.push(`Banco: ${bill.conta[column].banco}; Ag: ${bill.conta[column].agencia}; Núm: ${bill.conta[column].numero}`);
                            }
                            else {
                                actualRow.push(bill.conta[column].nome);
                            }
                        }
                        else if (bill.conta[column] === null) {
                            actualRow.push("");
                        }
                        else {
                                actualRow.push(bill.conta[column]);
                        }
                    }
                }
                actualTable.rows.push(actualRow);
            }
        }
        actualTable.rows.push(["TOTAL:", "", "", "", "", "",formatCurrency.format(actualTable.total)])
        
        const headers = fields.map(field => {
            const objArray = companyBillFields.find(obj => obj.field === field);
            return objArray.header;
        })
        if(actualTable.rows.length > 0){
            actualTable.headers = headers;
            reportTables.push(actualTable)
        }
    }
    generatePDFManyTables(title, fileName,reportTables, { bold: true});
}

const generateReportCollaborators = async (collaborators, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(collaboratorFields)[1];
    }
    const reportRows = [];
    for (const collaborator of collaborators) {
        const actualRow = [];

        for (const column of fields) {
            if (column in collaborator) {
                if (column === 'telefone'){
                    actualRow.push(collaborator['ddi'] + " " + collaborator[column]);
                }
                else if(column === 'salario') {
                    actualRow.push(formatterBR.format(collaborator[column]))   
                }
                else if (column === "data_admissao") {
                    actualRow.push(collaborator[column].split("-").reverse().join("/"));
                }
                else {
                    actualRow.push(collaborator[column]);
                }
            }
            else {
                actualRow.push(" ");
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = collaboratorFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}

const generateReportCollaboratorsPayments = async (collaboratorPayments, title, fields = null, fileName = "relatorio") =>{
    if (fields === null) {
        fields = separateHeaderField(collaboratorPaymentFields)[1];
    }
    const reportRows = [];
    for (const collaboratorPayment of collaboratorPayments) {
        const actualRow = [];

        for (const column of fields) {
            if (column in collaboratorPayment) {
                if (column.includes("data")){
                    actualRow.push(collaboratorPayment[column].split("-").reverse().join("/"));
                }
                else if(column === 'valor_pago') {
                    actualRow.push(formatterBR.format(collaboratorPayment[column]))   
                }
            }
            else {
                actualRow.push(" ");
            }
        }
        reportRows.push(actualRow);
    }
    const headers = fields.map(field => {
        const objArray = collaboratorPaymentFields.find(obj => obj.field === field);
        return objArray.header;
    })
    generatePDF(title, fileName,headers, reportRows);
}



const billFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Descrição',
        field: 'descricao'
    },
    {
        header: 'Empresa',
        field: 'empresa'
    },
    {
        header: 'Fornecedor',
        field: 'parceiro'
    },
    {
        header: 'Cliente',
        field: 'parceiro'
    },
    {
        header: 'Número da Nota Fiscal',
        field: 'identificadorNota'
    },
    {
        header: 'Centro de Custo',
        field: 'centro_de_custo'
    },
    {
        header: 'Plano de Contas',
        field: 'plano_de_contas'
    },
    {
        header: 'Conta Bancária',
        field: 'conta_bancaria'
    },
    {
        header: 'Forma de Pagamento',
        field: 'forma_de_pagamento'
    },
    /* {
        header: 'Produto',
        field: 'produto'
    },
    {
        header: 'Quantidade',
        field: 'quantidade'
    }, */
    {
        header: 'Paga',
        field: 'paga'
    },
    {
        header: 'Valor',
        field: 'valor'
    },
    {
        header: 'Valor Pago',
        field: 'valor_pago'
    },
    {
        header: 'Número Parcela',
        field: 'numero_parcela'
    },
    {
        header: 'Parcelas',
        field: 'numero_parcelas'
    },
    {
        header: 'Data de Vencimento',
        field: 'data_venc'
    },
    {
        header: 'Data de Pagamento',
        field: 'data_pag'
    },
]

const collaboratorBillFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Descrição',
        field: 'descricao'
    },
    {
        header: 'Empresa',
        field: 'empresa'
    },
    {
        header: 'Colaborador',
        field: 'colaborador'
    },
    {
        header: 'Conta Bancária',
        field: 'conta_bancaria'
    },
    {
        header: 'Forma de Pagamento',
        field: 'forma_de_pagamento'
    },
    /* {
        header: 'Produto',
        field: 'produto'
    },
    {
        header: 'Quantidade',
        field: 'quantidade'
    }, */
    {
        header: 'Paga',
        field: 'paga'
    },
    {
        header: 'Valor Total',
        field: 'valor_total'
    },
    {
        header: 'Valor Pago',
        field: 'valor_pago'
    },
    {
        header: 'Parcelas',
        field: 'numero_parcelas'
    },
    {
        header: 'Parcelas Pagas',
        field: 'numero_parcelas_pagas'
    },
    {
        header: 'Data de Vencimento',
        field: 'data_venc'
    },
]

const stockFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Centro de Custo',
        field: 'centro_de_custo'
    },
    {
        header: 'Plano de Contas',
        field: 'plano_de_contas'
    },
    {
        header: 'Tipo',
        field: 'tipo'
    },
    {
        header: 'Categoria',
        field: 'categoria'
    },
    {
        header: 'Quantidade',
        field: 'quantidade'
    },
    {
        header: 'Quantidade Crítica',
        field: 'quantidade_critica'
    },
]

const stockHistoricFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Descrição',
        field: 'descricao'
    },
    {
        header: 'Tipo',
        field: 'tipo'
    },
    {
        header: 'Quantidade',
        field: 'quantidade'
    },
    {
        header: 'Data',
        field: 'data'
    },
]

const bankAccountFields = [
    /* {
        header: 'ID',
        field: 'id'
    }, */
    {
        header: 'Banco',
        field: 'banco'
    },
    {
        header: 'Agência',
        field: 'agencia'
    },
    {
        header: 'Número',
        field: 'numero'
    },
    {
        header: 'Tipo',
        field: 'tipo'
    },
    {
        header: 'Saldo',
        field: 'saldo'
    },
]

const recordFields = [
    {
        header: 'Nome',
        field: 'nome',
    },
]

const bankAccountTransferFields = [
    {
        header: 'Conta Bancária Origem',
        field: 'conta_origem'
    },
    {
        header: 'Conta Bancária Destino',
        field: 'conta_destino'
    },
    {
        header: 'Valor',
        field: 'valor'
    },
    {
        header: 'Data',
        field: 'data'
    },
    {
        header: 'Descrição',
        field: 'descricao'
    },
]

const partnerFields = [
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'Pessoa',
        field: 'tipo'
    },
    {
        header: 'Documento',
        field: 'documento'
    },
    {
        header: 'Cidade',
        field: 'cidade'
    },
    {
        header: 'Estado',
        field: 'estado'
    },
    {
        header: 'Logradouro',
        field: 'logradouro'
    },
    {
        header: 'CEP',
        field: 'cep'
    },
];

const companyBillFields = [
    {
        header: 'Descrição',
        field: 'descricao'
    },
    {
        header: 'Tipo',
        field: 'tipo'
    },
    {
        header: 'Centro de Custo',
        field: 'centro_de_custo'
    },
    {
        header: 'Plano de Contas',
        field: 'plano_de_contas'
    },
    {
        header: 'Conta Bancária',
        field: 'conta_bancaria'
    },
    {
        header: 'Data de Pagamento',
        field: 'data_pag'
    },
    {
        header: 'Valor Pago',
        field: 'valor_pago'
    },
]


const collaboratorFields = [
    {
        header: 'Nome',
        field: 'nome'
    },
    {
        header: 'CPF',
        field: 'documento'
    },
    {
        header: 'Estado',
        field: 'estado'
    },
    {
        header: 'Cidade',
        field: 'cidade'
    },
    {
        header: 'Bairro',
        field: 'bairro'
    },
    {
        header: 'CEP',
        field: 'cep'
    },
    {
        header: 'Logradouro',
        field: 'logradouro'
    },
    {
        header: 'Telefone',
        field: 'telefone'
    },
    {
        header: 'Data de Admissão',
        field: 'data_admissao'
    },
    {
        header: 'Salario',
        field: 'salario'
    },
    {
        header: 'Cargo',
        field: 'cargo'
    },
    {
        header: 'Dias de ferias',
        field: 'ferias'
    },
]

const collaboratorPaymentFields = [
    {
        header: 'Data Referente',
        field: 'data_referente'
    },
    {
        header: 'Data do Pagamento',
        field: 'data'
    },
    {
        header: 'Valor Pago',
        field: 'valor_pago'
    },
]
    




const reportServices = {
    generatePDF,
    generateReportStudents,
    generateReportCoaches,
    generateReportClasses,
    generateReportCallLists,
    generateReportAcademyBills,
    generateReportBills,
    generateReportCollaboratorBills,
    generateReportCompanyBills,
    generateReportStock,
    generateReportStockHistoric,
    generateReportBankAccouts,
    generateReportBankAccoutTransfers,
    generateReportPartners,
    generateReportRecords,
    generateReportCollaborators,
    generateReportCollaboratorsPayments,
    separateHeaderField,
    studentFields,
    coachFields,
    classFields,
    academyBillFields,
    billFields,
    collaboratorBillFields,
    stockFields,
    stockHistoricFields,
    bankAccountFields,
    bankAccountTransferFields,
    partnerFields,
    recordFields,
    collaboratorFields,
    collaboratorPaymentFields
}
export default reportServices;